import { render, staticRenderFns } from "./CandidateLogMessages.vue?vue&type=template&id=2c5dc198&"
import script from "./CandidateLogMessages.vue?vue&type=script&lang=js&"
export * from "./CandidateLogMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports